
define('text!templates/modals/select-deal/content-loading.ejs',[],function () { return '<div class="alert">Загрузка</div>';});

